export enum ReportLostCardCompleteStage {
  ReportLostCardComplete = 'ReportLostCardComplete',
}

export interface ReportLostCardCompleteState {
  stage: ReportLostCardCompleteStage.ReportLostCardComplete
  isAdmin: boolean
}
